import * as React from 'react';
import { useTenantBranding } from '@/branding/TenantBrandingProvider';

/**
 * `<DynamicFavicon />` (W5-F1-S3) — swaps the `<link rel="icon">` href to
 * `tenant_branding.favicon_url` whenever the resolved branding changes.
 * When the URL is null, falls back to the page's original favicon (set in
 * `apps/web/index.html`).
 *
 * Renders nothing; effect-only. Mount once near the root (under
 * `<TenantBrandingProvider>` in `main.tsx`).
 */
export function DynamicFavicon(): null {
  const { branding } = useTenantBranding();

  React.useEffect(() => {
    if (typeof document === 'undefined') return;

    const link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (!link) return;

    // Stash the original href once so we can restore it if branding flips
    // back to defaults (e.g. after the partner deletes their custom favicon).
    if (!link.dataset.originalHref) {
      link.dataset.originalHref = link.href;
    }

    if (branding.favicon_url) {
      link.href = branding.favicon_url;
    } else if (link.dataset.originalHref) {
      link.href = link.dataset.originalHref;
    }
  }, [branding.favicon_url]);

  return null;
}
